import { createContext, useContext, useEffect, useState } from 'react';

const KEY = 'rmg_hr_theme';
const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const initial = () =>
  localStorage.getItem(KEY)
  ?? (window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark');

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(initial);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}
